import { useEffect } from 'react';
import { Text } from 'foundations-components/components/Text';
import { useDispatch } from 'react-redux';
import { View } from 'foundations-components/components/View';
import { Flex } from 'foundations-components/components/Flex';
import { setErrorMessages } from '../../state/errorMessagesSlice';
import { useGetErrorMessagesAndTranslations } from '../../hooks/useGetErrorMessagesAndTranslations';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function FutureChargesValidationMessages({
  currencyCode,
  isRecurringTotalBelowMin,
  isRecurringTotalAboveMax,
  maximumAmount,
  minimumAmount,
  topMargin
}) {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setErrorMessages({
      recurringTotalOverMax: {
        isError: isRecurringTotalAboveMax,
        totalsOptions: {
          currencyCode,
          maximumAmount
        }
      },
      recurringFutureTotalBelowMin: {
        isError: isRecurringTotalBelowMin,
        totalsOptions: {
          currencyCode,
          minimumAmount
        }
      }
    }));
  }, [dispatch, currencyCode, isRecurringTotalAboveMax, isRecurringTotalBelowMin, maximumAmount, minimumAmount]);
  const totalBelowMinMessage = useGetErrorMessagesAndTranslations().get('recurringTotalBelowMin');
  const totalOverMaxMessage = useGetErrorMessagesAndTranslations().get('recurringTotalOverMax');
  return /*#__PURE__*/_jsxs(View, {
    marginBlockStart: topMargin,
    children: [isRecurringTotalBelowMin && /*#__PURE__*/_jsx(Flex, {
      justifyContent: "end",
      children: /*#__PURE__*/_jsx(View, {
        paddingInlineEnd: "600",
        children: /*#__PURE__*/_jsx(Text, {
          marginBlockEnd: "400",
          "data-test-id": "minimum-recurring-validation-error-message",
          as: "p",
          typography: "detail-100",
          color: "text-alert-default",
          textAlign: "right",
          children: totalBelowMinMessage
        })
      })
    }), isRecurringTotalAboveMax && /*#__PURE__*/_jsx(Flex, {
      justifyContent: "end",
      children: /*#__PURE__*/_jsx(View, {
        paddingInlineEnd: "600",
        children: /*#__PURE__*/_jsx(Text, {
          marginBlockEnd: "400",
          "data-test-id": "maximum-recurring-validation-error-message",
          as: "p",
          typography: "detail-100",
          color: "text-alert-default",
          textAlign: "right",
          children: totalOverMaxMessage
        })
      })
    })]
  });
}